import { BrowserRouter, useNavigate } from "react-router-dom";
import RoutesList from "./Routes";
import Login from "./Auth/Login/Login";

import ScrollToTopButton from "./Components/ScrollToTop/ScrollToTopButton";


import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { setNavigate } from "./Utils/NavigationService";

function NavigationInitializer() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  return null;
}


function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <NavigationInitializer />
      <RoutesList />

      <Login />

      <ToastContainer />
      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;
